module.exports = __webpack_public_path__ + "static/media/galerija_2022_0030.dc6287de.jpg";